<script>
  import { Button, Icon } from "framework7-svelte";
  import { downloadCsv } from "../../utils/csvExporter";

  export let filename = "export.csv";
  export let columns = [];
  export let data = [];
  export let label = "Export CSV";
  export let outline = true;
  export let color = "blue";
  export let small = false;
  export let disabled = false;

  let exporting = false;

  function handleExport() {
    if (disabled || exporting || !data || !data.length) return;
    try {
      exporting = true;
      downloadCsv(filename, columns, data);
    } catch (err) {
      console.error("Failed to export CSV:", err);
      if (typeof window !== "undefined" && window.f7) {
        window.f7.dialog.alert("Failed to generate CSV export: " + err.message);
      }
    } finally {
      setTimeout(() => {
        exporting = false;
      }, 500);
    }
  }
</script>

<Button
  {outline}
  {color}
  {small}
  disabled={disabled || exporting || !data || data.length === 0}
  on:click={handleExport}
  class="csv-export-button"
>
  {#if exporting}
    <span class="export-spinner">⏳</span>
    <span>Exporting...</span>
  {:else}
    <span class="export-icon">📥</span>
    <span>{label}</span>
    {#if data && data.length > 0}
      <span class="export-count">({data.length})</span>
    {/if}
  {/if}
</Button>

<style>
  :global(.csv-export-button) {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    text-transform: none;
    letter-spacing: 0.2px;
  }

  .export-icon,
  .export-spinner {
    font-size: 14px;
    line-height: 1;
  }

  .export-count {
    font-size: 11px;
    opacity: 0.8;
  }
</style>
